import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Shield } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PriceBlock() {
  return <section id="precio" className="py-24 px-4 relative" data-id="element-146">
      <div className="max-w-3xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-[#111827] to-[#0a0f1a] border-2 border-emerald-500/50 rounded-3xl p-8 md:p-12 text-center relative shadow-[0_0_50px_rgba(16,185,129,0.15)] overflow-hidden" data-id="element-148">
          {/* Top highlight line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-emerald-400 to-transparent" data-id="element-149" />

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 leading-relaxed" data-id="element-150">
            Hoy podés acceder a{' '}
            <span className="text-emerald-400" data-id="element-151">Freelance Express</span>: El
            Manual de Arbitraje de Micro-tareas{' '}
            <span className="text-emerald-400" data-id="element-152">
              + la Colección Completa de las 5 Micro-tareas con IA
            </span>{' '}
            — todo el sistema llave en mano para que empieces a facturar en
            dólares antes de que la inflación te coma otro sueldo.
          </h2>

          <div className="my-10" data-id="element-153">
            <p className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-154">
              Precio Especial
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-155">
              <span className="text-3xl md:text-5xl font-black text-gray-500 line-through decoration-red-500/70 decoration-[3px]" data-id="element-156">
                $79.999
              </span>
            </div>
            <div className="mt-4 mb-2" data-id="element-157">
              <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-500/20 border border-emerald-500/40 text-emerald-400 text-sm font-bold uppercase tracking-widest animate-pulse" data-id="element-158">
                🚀 Precio de Lanzamiento
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 mt-3" data-id="element-159">
              <span className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-emerald-200" data-id="element-160">
                $39.999
              </span>
            </div>
            <p className="text-emerald-500 font-medium mt-2" data-id="element-161">(Pago único)</p>
          </div>

          <p className="text-lg text-gray-300 mb-10 max-w-xl mx-auto" data-id="element-162">
            Menos de lo que cuesta una cena afuera, para comprar la salida de
            una economía que te tiene atrapado.
          </p>

          <div className="max-w-md mx-auto" data-id="element-163">
            <CTAButton className="w-full py-5 text-lg" href="https://multiebookstudio.shop/cart/46977098940567:1" data-id="element-164" />

            <div className="mt-6 flex flex-col items-center gap-3 text-sm text-gray-400" data-id="element-165">
              <div className="flex items-center gap-2" data-id="element-166">
                <Lock className="w-4 h-4" data-id="element-167" />
                <span data-id="element-168">Acceso inmediato tras el pago. Seguro y privado.</span>
              </div>
              <div className="flex gap-4 opacity-50" data-id="element-169">
                <Shield className="w-6 h-6" data-id="element-170" />
                {/* Visual representation of secure payments */}
                <div className="flex gap-2 items-center font-mono font-bold" data-id="element-171">
                  SECURE CHECKOUT
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}